import { createAppAsyncThunk } from '@/store/thunks/createAppAsyncThunk';

export const clearLogsThunk = createAppAsyncThunk<undefined>(
  'debug/clearLogs',
  (_, { extra: { loggerService } }) => {
    loggerService.clearLogs();
    return undefined;
  }
);
